function enterKeyCheck(event, buttonID) {
    //click submit button if key pressed was enter
    if (event.keyCode == 13) {
        event.preventDefault();
        var btn = $('#' + buttonID);
        btn.click();
    }
}

function validateZipCode(textboxID) {
    var txtbx = $('#' + textboxID);

    //validate the zip code is in either 12345 or 12345-6789 format
    var ZipCode = txtbx.val();
    var isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)|(^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,8}.-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,8})/.test(ZipCode);

    if (isValidZip) {
        destroyTooltip(textboxID);
        return true;
    } else {
        displayTooltip(textboxID, 'Please enter a valid Zip Code.');
        return false;
    }
}

//removes bootstrap tooltip if it exists
function destroyTooltip(elementID) {
    var elem = $('#' + elementID);
    elem.tooltip('destroy');
}

//adds bootstrap tooltip to element
function displayTooltip(elementID, displayText) {
    var elem = $('#' + elementID);
    var tooltipID = elem.attr('aria-describedby');

    if (typeof tooltipID != "undefined") {
        if ($("#" + tooltipID).length > 0) {
            // tooltip already visible
            return false;
        }
    }

    elem.tooltip({
        'trigger': 'manual',
        'placement': 'bottom',        
        'title': displayText
    });

    elem.tooltip('show');
}

//handles the click event for the get quote submit button
function submitGetQuote(e) {
    e.preventDefault();

    //validate zip code
    var isValidZip = validateZipCode('GetQuoteZipCode');

    if (isValidZip) {
        //GetQuoteForm.submit();
        console.log('get quote');
        var zipCode = $("#GetQuoteZipCode").val();
        var quoteType = $("#SelectedQuoteType").val();
        var agentCode = $("#AgentCode").val();
        var campaignParams = $("#CampaignParameters").val();
        var quoteUrl = "";

        switch (quoteType) {
            case "Auto":
                quoteUrl = $("#AutoQuoteUrl").val() + zipCode;
                break;
            case "Renters":
                quoteUrl = $("#RentersQuoteUrl").val() + zipCode;
                break;
            case "AutoRenters":
                quoteUrl = $("#AutoRentersQuoteUrl").val() + zipCode;
                break;
        }

        if (agentCode.length > 0) {
            quoteUrl += "?agent=" + agentCode;
            if (campaignParams.length > 0) {
                quoteUrl += "&" + campaignParams;
            }
        } else if (campaignParams.length > 0) {
            quoteUrl += "?" + campaignParams;
        }

        window.location.href = quoteUrl;
    }
}

//handles the click event for the find agent submit button
function submitFindAgent(e) {
    e.preventDefault();

    //validate zip code
    var isValidZip = validateZipCode('FindAgentZipCode');

    if (isValidZip) {
        FindAgentForm.submit();
    }
}

// media query event handler
if (matchMedia) {
    var mq = window.matchMedia("(max-width: 991px)");
    mq.addListener(MoveWidgets);
    MoveWidgets(mq);
}

// media query change
function MoveWidgets(mq) {

    if ($("#mobile-widget-container").length && $("#desktop-widget-container").length) {

        if (mq.matches) {
            // window width is less than 991pxpx            
            ($("#desktop-widget-container").children()).prependTo("#mobile-widget-container");
            //Remove class from hero-right-block to leave room for big title and description when window width is less than 767px
            ($('#hero-right-block').removeClass());
            
        } else {
            // window width is greater than 991px
            ($("#mobile-widget-container").children()).prependTo("#desktop-widget-container");
            //Add hero-right-block classes back on when window width is greater than 767px
            ($('#hero-right-block').addClass('col-md-3 text-uppercase hero-right-block'));
        }
    }
}

//prevents scripting characters from being entered
$("input[type=text], textarea").on('keydown', function (e) {
    var inputChar = e.which || e.keyCode;

    //check if shift key is not being used
    if (e.shiftKey == false) {
        //shift key is not used
        //check for ' and /
        //removed check for 191 forward slash (/) to allow it in date fields
        // Remove the following If to allow user to input Apostrophes (') to their first and last name --- NN
        //if (inputChar == 222 ) {
        //    e.preventDefault();
        //    return;
        //}        
    } else {
        //shift key is used. Check for < > & "
        if (inputChar == 188 || inputChar == 190 || inputChar == 222) {
            e.preventDefault();
            return;
        }
    }
    
});


// Zip Code Location Tooltip
$("span[class^='location-span']").hover(function () {
    //console.log($(this)[0].id);
    displayTooltip($(this)[0].id, 'Detect Location');
    return false;
}, function () {
    destroyTooltip($(this)[0].id);
    return true;
});

$(function () {
    if(window.location.href.indexOf("agent-profile") > -1) 
    {
        AppendAgentContactLink(window.location.href.split('-')[window.location.href.split('-').length -1]);
    }
});
function AppendAgentContactLink(agentId) {
    if ($("#request-appointment-agent-link").length) {
        var link = $("#request-appointment-agent-link");
        link.attr('href', document.location.origin + '/find-agent/contact-agent/agent/' + agentId);
    }   
}

$(".alphaOnly").on('keydown', function (e) {
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
        // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
      ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
      (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return;
    }

    var inputChar = e.which || e.keyCode;
    //console.log(inputChar);
    if (inputChar == 32 || (inputChar > 36 && inputChar < 41) || (inputChar > 64 && inputChar < 91) || inputChar == 8 || /*inputChar == 188 ||*/ inputChar == 189 || /*inputChar == 190 ||*/ inputChar == 222) {
        //console.log("true");
        return;
    } else {
        //console.log("false");
        e.preventDefault();
        return;
    }
});